var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8594 4.39V19.39C15.8594 21.06 16.9994 22 18.2494 22C19.3894 22 20.6394 21.21 20.6394 19.39V4.5C20.6394 2.96 19.4994 2 18.2494 2C16.9994 2 15.8594 3.06 15.8594 4.39ZM9.60938 12V19.39C9.60938 21.07 10.7694 22 11.9994 22C13.1394 22 14.3894 21.21 14.3894 19.39V12.11C14.3894 10.57 13.2494 9.61 11.9994 9.61C10.7494 9.61 9.60938 10.67 9.60938 12ZM5.74938 17.23C7.06938 17.23 8.13938 18.3 8.13938 19.61C8.13938 20.2439 7.88757 20.8518 7.43936 21.3C6.99115 21.7482 6.38324 22 5.74938 22C5.11551 22 4.5076 21.7482 4.05939 21.3C3.61118 20.8518 3.35938 20.2439 3.35938 19.61C3.35937 18.3 4.42938 17.23 5.74938 17.23Z",
    fill: "#E17512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/Google-Analytics.690df3a4731446c945a9b4e5c4afdac7.svg";
export { ForwardRef as ReactComponent };